import { render } from "./ForgotPass.vue?vue&type=template&id=270015bf&scoped=true"
import script from "./ForgotPass.vue?vue&type=script&lang=js"
export * from "./ForgotPass.vue?vue&type=script&lang=js"

import "./ForgotPass.vue?vue&type=style&index=0&id=270015bf&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270015bf"]])

export default __exports__